/**
 * Puzzle 2 — Commentary Booth data.
 */

// Staging builds often fail to serve hashed webpack mp3 URLs — use S3 as primary.
export const COMMENTARY_CLIP_SRC =
  "https://2023-extramileplay-php.s3.ap-south-1.amazonaws.com/cricket.mp3";

/** Points written to DB `stage2` on success. */
export const COMMENTARY_BOOTH_POINTS = 100;

/** Puzzle 3 hotspot unlocked after Commentary Booth success. */
export const COMMENTARY_BOOTH_UNLOCKS = "museum_archive";

/**
 * Modular audio asset descriptor.
 * Keep `mockDurationSec` as fallback if the file fails to load.
 */
export const COMMENTARY_CLIP = {
  id: "wc2011_final",
  label: "2011 ICC Cricket World Cup Final — India wins",
  src: COMMENTARY_CLIP_SRC,
  mockDurationSec: 8,
};

export const COMMENTARY_QUESTIONS = [
  {
    id: "q1",
    prompt: "Which tournament is being played?",
    options: [
      { id: "a", label: "ICC Champions Trophy" },
      { id: "b", label: "ICC Cricket World Cup" },
      { id: "c", label: "Asia Cup" },
      { id: "d", label: "T20 World Cup" },
    ],
    correctOptionId: "b",
  },
  {
    id: "q2",
    prompt: "Who hits the winning shot?",
    options: [
      { id: "a", label: "Virender Sehwag" },
      { id: "b", label: "MS Dhoni" },
      { id: "c", label: "Gautam Gambhir" },
      { id: "d", label: "Yuvraj Singh" },
    ],
    correctOptionId: "b",
  },
  {
    id: "q3",
    prompt: "Which team did India defeat?",
    options: [
      { id: "a", label: "Australia" },
      { id: "b", label: "Pakistan" },
      { id: "c", label: "Sri Lanka" },
      { id: "d", label: "England" },
    ],
    correctOptionId: "c",
  },
  {
    id: "q4",
    prompt: "In which city was the match played?",
    options: [
      { id: "a", label: "Delhi" },
      { id: "b", label: "Chennai" },
      { id: "c", label: "Mumbai" },
      { id: "d", label: "Kolkata" },
    ],
    correctOptionId: "c",
  },
  {
    id: "q5",
    prompt: "What does the commentator say immediately after the winning shot?",
    options: [
      { id: "a", label: "What a finish!" },
      { id: "b", label: "India are champions!" },
      { id: "c", label: "Dhoni finishes off in style!" },
      { id: "d", label: "History created!" },
    ],
    correctOptionId: "c",
  },
];

/**
 * @param {Record<string, string|null|undefined>} answers questionId -> optionId
 * @returns {{ ok: boolean, wrongIds: string[], missingIds: string[], correctCount: number }}
 */
export function validateCommentaryAnswers(
  answers,
  questions = COMMENTARY_QUESTIONS
) {
  const wrongIds = [];
  const missingIds = [];
  let correctCount = 0;

  questions.forEach((q) => {
    const selected = answers[q.id];
    if (selected == null || selected === "") {
      missingIds.push(q.id);
      return;
    }
    if (selected === q.correctOptionId) {
      correctCount += 1;
    } else {
      wrongIds.push(q.id);
    }
  });

  return {
    ok: wrongIds.length === 0 && missingIds.length === 0,
    wrongIds,
    missingIds,
    correctCount,
  };
}
